import React from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import PropTypes from "prop-types"; //  Import PropTypes
import LoadingPage from "./pages/LoadingPage";


const PrivateRoute = ({ component: Component, ...rest }) => {
  const {user, loading} = useAuth();

  
  if (loading) {
    return <LoadingPage loading={loading}/>;
  }
  

  

  /*return (
    <Route
      {...rest}
      render={(props) =>
        <Component {...props} /> 
      }
    />
  );*/
  return (
    <Route
      {...rest}
      render={(props) =>
        
          user?.token ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired, // Ensure component is a valid React component
};

export default PrivateRoute;
